import { ProjectRolesConfig } from '@luzula/luzula-lib';

/**
 * Projekt-Rollen-Konfiguration für bpweb (Mitglieder-Zuweisung + Kommentar-Rollen).
 *
 * ACHTUNG — zwei unterschiedliche Namensräume in dieser Config:
 *
 *  - `authRole` ist der **rohe Keycloak-Client-Rollenname**, gegen den die
 *    Mitglieder-Auswahl filtert (`getUserClientRolesExpanded(user, 'bpweb')`).
 *    Der Keycloak-Realm wird NICHT migriert (User-Entscheidung 2026-05-22, siehe
 *    `AuthService.normalizeRole`): die Bearbeiter-Rolle heißt dort dauerhaft
 *    **`role:kartierer`**, NICHT `role:bearbeiter`. Steht hier der falsche Name,
 *    erscheinen im „Bearbeiter eintragen"-Dialog keine Benutzer.
 *
 *  - `commentReviewerRoles` / `commentNoSeverityRoles` nutzen dagegen die
 *    **normalisierten App-Rollennamen** (kartierer→bearbeiter, gast→datennutzer),
 *    weil sie gegen die aufgelöste App-Rolle geprüft werden, nicht gegen Keycloak.
 */
export const bpwebProjectRolesConfig: ProjectRolesConfig = {
	keycloakClient: 'bpweb',
	memberRoles: [
		{
			// appRole = normalisierter App-Rollenname (kartierer→bearbeiter), gegen den
			// canIbe('bearbeiter') prüft. Aktiviert den member-aware canIbe-Default in
			// BaseProjectService (globale Rolle UND Eintrag in `bearbeiter[]`).
			appRole: 'bearbeiter',
			field: 'bearbeiter', label: 'Bearbeiter', labelPlural: 'Bearbeiter',
			// Keycloak-Rolle bleibt `role:kartierer` (Realm nicht migriert) — NICHT auf
			// `role:bearbeiter` ändern, sonst ist die Bearbeiter-Auswahl leer.
			authRole: 'role:kartierer', icon: 'bi-pencil'
		},
		{
			appRole: 'kontrolleur',
			field: 'kontrolleure', label: 'Kontrolleur', labelPlural: 'Kontrolleure',
			authRole: 'role:kontrolleur', icon: 'bi-check-circle',
			dependsOnPermission: 'aendern'
		}
	],
	commentReviewerRoles: ['kontrolleur', 'entwickler'],
	commentNoSeverityRoles: ['bearbeiter']
};
